<template>
  <div class="px-4">
    <div class="flex justify-between items-center gap-4 mb-4">
      <div class="text-xs text-text">{{ heading }}</div>
      <div class="h-px bg-surface-grey flex-1"></div>

      <div
        class="flex"
        v-if="
          type == 'ticket' &&
          route.name !== 'checkout-receipt' &&
          route.name !== 'checkout-payment' 
        "
      >

        <button 
          @click="cart.gotoTicketReservation(id)"
          type="button"
          class="text-xs underline ml-4 cursor-pointer"
        >
          {{ $t('common.edit') }}
        </button>

        <button
          @click="cart.removeFromCart(id, true)"
          type="button"
          class="text-xs underline ml-4 cursor-pointer"
          v-if="route.name !== 'checkout-information' && route.name !== 'checkout-tickets'"
        >
          {{ $t('common.remove') }}
        </button>
      </div>
    </div>
    <div class="space-y-2">
      <div v-for="item in items" :key="item.name1" class="flex justify-between">
        <div class="flex items-center gap-1">
          <div class="flex items-start gap-1">
            <span class="font-semibold whitespace-nowrap"
              >{{ item.count }} {{ $t('common.pcs') }}</span
            >
            <span class="text-text">·</span>
            <div>
              <div>{{ getLocalizedTicketValue(item, locale, 'name1', 50) }}</div>
              <div class="text-xs text-text line-clamp-1">
                <span v-if="item.flexData">
                  <button
                    type="button"
                    class="underline mr-1 cursor-pointer"
                    @click="infoModal = true"
                  >
                    {{ $t('checkout.show_info') }}
                  </button>

                  {{ item.flexData }}
                </span>
                <span v-if="item.discountText">
                  {{ item.discountText }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="font-semibold" v-if="item.price">
          {{
            formatPrice(item.price * item.count, item.currency, $i18n.locale)
          }}
        </div>
      </div>
    </div>

    <BaseModal v-model="infoModal">
      <template #header>{{ $t('checkout.ticket_info') }}</template>

      <div class="p-6">
        <div class="font-semibold mb-4">#1 billet</div>
        <div class="text-sm">
          <div class="font-semibold mb-2">Program</div>
          <div class="space-y-2 text-text">
            <p>
              Her kan du tilføje informationer om din billet. Det kan være
              allergener, madpræferencer eller andre relevante oplysninger.
            </p>
            <p>
              Villads Leth - AI Agenter - Sådan bruger du dem til at 10x din
              produktivitet
            </p>
            <p>
              Mads Haukrogh - Go Big or Go Home - The Power of Big Splash
              Campaigns
            </p>
            <p>
              Malte Lange - 6 skarpe LinkedIn Ads-hacks: Få flere og bedre leads
              - uden at øge dit budg
            </p>
            <p>
              Bonnie Groth Frølund - Marketingchefens guide: Leadgenerering for
              B2B virksomheder
            </p>
          </div>
        </div>

        <div class="mt-4">
          <div class="font-semibold mb-2 text-sm">Deltager info</div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <div class="text-text text-xs">Deltager for- og efternavn</div>
              <div class="text-sm">Malte Lange</div>
            </div>
            <div>
              <div class="text-text text-xs">Deltager e-mail</div>
              <div class="text-sm">kd@29x.studio</div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useRoute } from 'vue-router';

  import { useCartStore } from '@/stores/cart';
  import type { Addon, Ticket } from '@/types';
  import { formatPrice } from '@/utils/formatPrice';

  import BaseModal from '../ui/BaseModal.vue';
  import { useI18n } from 'vue-i18n';
  import { getLocalizedTicketValue } from '@/utils/ticketItemUtil';

  const cart = useCartStore();

  const route = useRoute();

  const infoModal = ref(false);

  const { locale } = useI18n();

  defineProps<{
    heading: string;
    type: 'addon' | 'ticket';
    id: number;
    items: Addon[] | Ticket[];
  }>();
</script>
